import { render } from "./EntityCard.vue?vue&type=template&id=5445cc2b&scoped=true"
import script from "./EntityCard.vue?vue&type=script&lang=js"
export * from "./EntityCard.vue?vue&type=script&lang=js"

import "./EntityCard.vue?vue&type=style&index=0&id=5445cc2b&scoped=true&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/oztagaustralia-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5445cc2b"]])

export default __exports__